import styled, { keyframes } from 'styled-components'

export const PromoSection = styled.section`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column-reverse;
    gap: 25px;
    margin-bottom: 39px;
  `}
`

export const PromoBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 694px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-items: center;
  `}
`

export const PromoTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 35px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-items: center;
    margin-bottom: 25px;
    width: 100%;
  `}
`

export const PromoTitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-content: center;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
    flex-wrap: wrap;
  `}
`

export const PromoTitle = styled.h2`
  font-size: 52px;
  font-weight: 600;
  line-height: 68px;
  margin: 0;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 30px;
    line-height: 39px;
    text-align: center;
  `}
`

export const PromoLogo = styled.img`
  height: 54px;
  width: 160px;
  margin-right: 15px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: 30px;
    width: 88px;
  `}
`

export const PromoDescription = styled.p`
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.5px;
  margin: 0 0 25px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  text-align: center;
`}
`

export const PromoAppLinks = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-items: center;
  `}
`

export const PromoAppLink = styled.a`
  max-width: 155px;
  width: 100%;
  display: block;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 122px;
  `}
`

export const PromoAppImage = styled.img`
  max-width: 155px;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 122px;
  `}
`

export const PromoSideImages = styled.div<{ isLifeWallet?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 450px;
  height: 477px;

  ${({ theme, isLifeWallet }) => theme.mediaWidth.upToSmall`
    max-width: 284px;
    height: 300px;
    ${isLifeWallet ? 'margin-bottom: 0' : 'margin-bottom: 50px;'}
  `};
`

const moveLeftPhone = keyframes`
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0);
  }
`

const moveRightPhone = keyframes`
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(5deg);
  }
  100% {
    transform: rotate(0);
  }
`

export const PromoSideLeftImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 268px;
  height: 376px;
  object-fit: contain;
  animation: ${moveLeftPhone} 8s infinite linear;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 170px;
    height: 237px;
  `};
`

export const PromoSideRightImage = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 290px;
  height: 417px;
  object-fit: contain;
  animation: ${moveRightPhone} 8s infinite linear;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 183px;
    height: 263px;
  `};
`
